import React, { Component } from "react";
import { addSeconds, subMinutes } from "date-fns";
import { observer } from "mobx-react";

import { duration } from "@formant/core/model/duration";
import { HealthStatus } from "@formant/core/model/HealthStatus";
import { IStreamData } from "@formant/core/model/IStreamData";

import { observeStore, organizationStore, queryStore } from "../../../stores";
import { Table } from "../../common/Table";
import { IBaseModuleProps } from "../IBaseModuleProps";
import { Module } from "../Module";
import { IMetadataDataPoint } from "../utils/IMetadataDataPoint";
import { pointsByDevice } from "../utils/pointsByDevice";
import { HealthModuleRow } from "./HealthModuleRow";
import * as styles from "./index.scss";

@observer
export class HealthModule extends Component<IBaseModuleProps> {
    private data: IStreamData<"health">[] = [];

    public render() {
        const { streamName, filter, focused } = this.props;
        const { time } = observeStore;

        const startTime = subMinutes(time, 1);
        const endTime = addSeconds(time, 1);

        const queryData = queryStore.moduleQuery(
            filter,
            streamName,
            "health",
            startTime,
            endTime,
        );
        const loading = queryData === undefined;
        const tooMuchData = queryData === "too much data";

        this.data = (queryData !== "too much data" && queryData) || this.data;
        const data = this.data;

        const empty = data.length === 0;

        const statusSort: HealthStatus[] = [
            "error",
            "unknown",
            "operational",
            "offline",
        ];

        const offlineTime =
            organizationStore.onlineSensitivity * duration.second;

        const datas = pointsByDevice(data);

        const current = datas
            .map<IMetadataDataPoint<"health">>(
                ({ deviceId, name, type, points }) => {
                    const recent = points.slice().reverse();

                    const last = recent.length > 0 ? recent[0] : undefined;

                    const lastNotOffline = recent.find(
                        ({ value }) => value.status !== "offline",
                    );

                    const expired =
                        lastNotOffline &&
                        time.getTime() - lastNotOffline.time.getTime() >
                            offlineTime;

                    const tags = last ? last.tags : {};

                    const pointTime = last ? last.time : time;

                    const status =
                        !last || expired ? "offline" : last.value.status;

                    return {
                        deviceId,
                        name,
                        type,
                        tags,
                        time: pointTime,
                        value: {
                            status,
                            clockSkewMs: last?.value.clockSkewMs,
                        },
                    };
                },
            )
            .sort(
                (a, b) =>
                    statusSort.indexOf(a.value.status) -
                    statusSort.indexOf(b.value.status),
            );

        const rows = current.map((_, i) => (
            <HealthModuleRow key={i} point={_} />
        ));

        return (
            <Module
                {...this.props}
                type="health"
                loading={loading}
                empty={empty}
                tooMuchData={tooMuchData}
                className={styles["health-module"]}
            >
                {rows?.length > 0 && (
                    <Table className={styles.table} disableScrolling={!focused}>
                        <thead>
                            <tr>
                                <th />
                                <th>
                                    <div>Device</div>
                                </th>
                                <th>
                                    <div>Tags</div>
                                </th>
                                <th>
                                    <div>Status</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>{rows}</tbody>
                    </Table>
                )}
            </Module>
        );
    }
}
